"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("../form");
function TabDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/tab.html',
        controller: /** @class */ (function (_super) {
            __extends(TabController, _super);
            function TabController($scope, book) {
                'ngInject';
                var _this = _super.call(this, $scope, book) || this;
                _this.valid = false;
                _this.setSingleCol(false);
                _this.form.value = book.getIndex(_this.prefix, _this.id);
                _this.setValue(_this.form.value);
                $scope.$watch(function () { return _this.form.isDisabled(); }, function (value) {
                    if (value) {
                        _this.form.setValidity(_this.form.validation, true);
                    }
                    else {
                        _this.form.setValidity(_this.form.validation, _this.valid);
                    }
                }, true);
                return _this;
            }
            TabController.prototype.onClick = function (value) {
                if (this.form.value !== value) {
                    this.valid = true;
                    this.form.setValidity(this.form.validation, this.valid);
                    this.setValue(value);
                }
                this.setPreviewPage(this.previewPage);
            };
            TabController.prototype.setValue = function (value) {
                this.form.value = value;
                this.book.update(this.prefix, this.id, value);
            };
            TabController.prototype.setPreviewPage = function (id) {
                if (isNaN(id)) {
                    return;
                }
                this.form.setPreviewPage(id);
            };
            return TabController;
        }(form_1.FormOptionController)),
        controllerAs: 'tabCtrl'
    };
}
exports.TabDirective = TabDirective;
